/* global axios */
import ApiClient from './ApiClient';

// Respostas das pesquisas: a fonte do relatório. Os comentários do responsável são notas
// aninhadas na resposta.
class SurveyResponsesAPI extends ApiClient {
  constructor() {
    super('survey_responses', { accountScoped: true });
  }

  getMetrics(params = {}) {
    return axios.get(`${this.url}/metrics`, { params });
  }

  download(params = {}) {
    return axios.get(`${this.url}/download`, { params });
  }

  getNotes(responseId) {
    return axios.get(`${this.url}/${responseId}/notes`);
  }

  createNote(responseId, content) {
    return axios.post(`${this.url}/${responseId}/notes`, {
      note: { content },
    });
  }

  deleteNote(responseId, noteId) {
    return axios.delete(`${this.url}/${responseId}/notes/${noteId}`);
  }
}

export default new SurveyResponsesAPI();
